import React from 'react';
import { Form, FormCard } from "./FormCard";

interface TicketFormsViewProps {
  deskTitle: string;
  forms: Form[];
  onEditForm?: (id: string) => void;
  onPreviewForm?: (id: string) => void;
}

export const TicketFormsView: React.FC<TicketFormsViewProps> = ({ 
  deskTitle, 
  forms, 
  onEditForm, 
  onPreviewForm 
}) => {
  return (
    <div className="max-w-7xl mx-auto animate-in fade-in duration-500 pb-20">
      <div className="mb-6">
        <h2 className="text-2xl font-bold mb-2">Request Forms</h2>
        <p className="text-muted-foreground">Manage and edit request forms for {deskTitle}</p>
      </div>

      {forms.length === 0 ? (
        <div className="p-20 text-center border-2 border-dashed rounded-xl bg-gray-50/50 shadow-sm">
          <p className="text-gray-500 font-medium">No forms found for this service desk.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {forms.map((form) => (
            <FormCard 
              key={form.id} 
              form={form} 
              onEdit={onEditForm} 
              onPreview={onPreviewForm} 
            />
          ))}
        </div>
      )}
    </div>
  );
};
